import * as React from 'react'
import { StyleSheet, View } from 'react-native'
import { useRouter } from 'solito/router'
import { Spacer } from '@components/Spacer'
import { CircleButton } from '@components/Tabs/CircleButton'
import { GlobalFilter } from '@components/Tabs/internal/GlobalFilter'
import { Title } from '@components/Tabs/internal/Title'
import { altWhite, white } from '@themes/Colors'
import type { Props } from './shared'

function ScreenHeaderWeb(props: Props): React.JSX.Element {
  const router = useRouter()

  const HeaderRight = props.headerRight
  return (
    <>
      <View style={styles.container} role="navigation">
        <View style={styles.row}>
          <Spacer noShrink width={8} />
          <View style={styles.left}>
            {props.backAction ? (
              <>
                <CircleButton
                  label="Back"
                  iconName="chevron-left"
                  iconPrefix="fas"
                  hideBorder
                  onPress={
                    props.backAction === true
                      ? () => router.back()
                      : props.backAction
                  }
                />
                <Spacer noShrink width={10} />
              </>
            ) : null}
            <Spacer noShrink width={8} />
            <View style={{ height: 32 }}>
              <Title headingLevel={1} text={props.title} />
            </View>
            <Spacer noShrink width={8} />
          </View>

          {HeaderRight ? (
            <View style={styles.right}>
              <HeaderRight
                canGoBack={!!props.backAction}
                tintColor={props.headerTintColor}
              />
            </View>
          ) : null}
          <Spacer noShrink width={8} />
        </View>
      </View>
      {props.searchConfig?.showSearch ? (
        <GlobalFilter
          onSearch={props.searchConfig.onSearch}
          placeholder={props.searchConfig.searchPlaceholder}
        />
      ) : null}
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    height: 50,
    borderBottomWidth: 1,
    borderBottomColor: altWhite,
    backgroundColor: white,
    position: 'sticky',
    top: 0,
    zIndex: 10,
    justifyContent: 'space-around',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  left: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
  },
  right: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
})

export default ScreenHeaderWeb
